import classes from "./helperIcon.module.css";
import { useState } from "react";
import { IconButton, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { allowEditHelps } from "src/data/ifs/allowIfs";
import { useUserData } from "src/context/userContext";

import HelperModal from "./components/HelperModal";
import HelperButton from "./components/HelperButton";
import HelperIconButton from "./components/HelperIconButton";
import HelpIcon from "src/components/icons/HelpIcons";

function HelperIcon({
  helpId,
  hide = false,
  alignRight: alignRightProp = true,
  onlyWide = false,
  component = "IconButton",
  variant = "outlined",
  txt = "info",
  height = "auto",
  text,
  textColor,
  fontSize,
  showIcon,
}) {
  const { user } = useUserData();
  const allowEdit = allowEditHelps(user);
  const [showModal, setShowModal] = useState(false);

  if (hide === true) return <></>;
  if (helpId === undefined) return <Typography color="error">NOHELPID</Typography>;

  const alignRight = alignRightProp === undefined ? true : alignRightProp;
  const onlyWideProp = onlyWide === true ? "onlyWide" : "";

  function handleKlik(e) {
    e.stopPropagation();
    setShowModal(true);
  }
  function handleCloseKlik() {
    setShowModal(false);
  }
  return (
    <>
      <HelperModal
        onSulje={handleCloseKlik}
        helpId={helpId}
        isModalOpen={showModal}
        allowEdit={allowEdit}
      />
      <div className={"noPrint center " + onlyWideProp}>
        {component === "Button" && (
          <HelperButton helpId={helpId} onClick={handleKlik} variant={variant} height={height} />
        )}
        {component === "IconButton" && (
          <HelperIconButton
            onClick={handleKlik}
            txt={txt}
            height={height}
            fontSize={fontSize}
            showIcon={showIcon}
          />
        )}
        {component === "Icon" && (
          <IconButton tabIndex={-1} onClick={handleKlik} aria-label="info">
            <HelpIcon />
          </IconButton>
        )}
        {component === "Text" && (
          <div
            className={alignRight ? classes.container : ""}
            onClick={handleKlik}
            style={{ cursor: "pointer" }}>
            <Typography variant="body2" sx={{ height: height || "auto" }} color={textColor}>
              {text || ""}
            </Typography>
          </div>
        )}
      </div>
    </>
  );
}
export default HelperIcon;

HelperIcon.propTypes = {
  helpId: PropTypes.string,
  hide: PropTypes.bool,
  alignRight: PropTypes.bool,
  onlyWide: PropTypes.bool,
  component: PropTypes.string,
  allowEdit: PropTypes.bool,
  variant: PropTypes.string,
  txt: PropTypes.string,
  height: PropTypes.string,
  text: PropTypes.string,
  textColor: PropTypes.string,
  fontSize: PropTypes.string,
  showIcon: PropTypes.bool,
};

/**
 * 
 * USAGE
 * 
  <HelperIcon
    helpId="TarjousTilaus" // required
    component="Button" // can be Button, IconButton, Icon, Text
    variant="outlined" // only for Button
    height="auto" // only for Button
  />
 
 */
